export * from './web-worker.interface';
export * from './web-worker.class';
